/* eslint-disable */
import { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WELCOME = {
  id: "welcome",
  from: "ai",
  text:
    "Hi, I'm Mason — Stephanie's wellness assistant. I can help with services, pricing, travel area, and booking. What can I help you with?",
};

export function useMasonChat() {
  const [messages, setMessages] = useState([WELCOME]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const send = async (text) => {
    const value = (text ?? input).trim();
    if (!value || loading) return;
    setMessages((m) => [...m, { id: `u-${Date.now()}`, from: "user", text: value }]);
    setInput("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/chat`, { message: value });
      setMessages((m) => [...m, { id: `a-${Date.now()}`, from: "ai", text: res.data.reply }]);
    } catch (e) {
      setMessages((m) => [
        ...m,
        {
          id: `a-${Date.now()}`,
          from: "ai",
          text: "I'm having trouble reaching the server. Please try again in a moment, or call us at (865) 221-7543.",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return { messages, input, setInput, loading, send };
}
